export const DEFAULT_INVALID_PHONE_ERROR_MESSAGE = 'Insira um telefone válido'
